<div mat-dialog-title>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="position: relative;margin-top: 20px;">
    <div class="close-dialog" mat-dialog-close style="display: none;">
      <span class="material-symbols-outlined">close</span>
    </div>
  </div>
</div>



<mat-dialog-content>

  <div style="text-align: center;">

    @if (cedio == false) {
      <div class="label-dialog-strong">Cede a través de un facturador<br> electrónico externo</div>
    }

    @if (cedio == false) {
      <div style="text-align: center;margin-bottom: 60px;margin-top: 40px;">
        <span class="material-symbols-outlined" style="font-size: 65px;color:var(--simpli-color6)">waving_hand</span>
      </div>
    }

    @if (cedio == true) {
      <div style="text-align: center;margin-bottom: 60px;margin-top: 40px;">
        <span class="material-symbols-outlined" style="font-size: 65px;color:var(--simpli-color7)">check_circle</span>
      </div>
    }

    @if (cedio == false) {
      <div class="label-dialog">Recuerda que al ceder por un facturador electrónico externo,<br> también estás aceptando las condiciones de esta operación.</div>
    }

    @if (cedio == true) {
      <div class="label-dialog">Una vez aplicada la cesión, podrás revisar el estado<br> de la recepción de tus facturas por esta plataforma.</div>
    }


    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

        <div class="btn-simpli-container">
          @if (cedio == false) {
            <button class="primary-button" mat-flat-button (click)="ceder()">
              Continuar
            </button>
          }

          @if (cedio == true) {
            <button class="primary-button" mat-flat-button (click)="close()">
              Ver estado
            </button>
          }

          @if (cedio == false) {
            <button class="secondary-button" mat-flat-button mat-dialog-close>
              Volver
            </button>
          }
        </div>

      </div>
    </div>

  </div>



</mat-dialog-content>